export default __webpack_public_path__ + "static/media/photo-07.1c1b7441.jpeg";